export const LOGOUT_USER = "LOGOUT_USER";

export const SET_USER = "SET_USER";
export const SET_ACTIVE_USER_ID = "SET_ACTIVE_USER_ID";
export const SET_ACTIVE_USER_TYPE = "SET_ACTIVE_USER_TYPE";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";

export const GET_CUSTOMERS = "GET_CUSTOMERS";
export const ADD_CUSTOMER = "ADD_CUSTOMER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";

export const GET_PRODUCTS = "GET_PRODUCTS";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";

export const GET_PRODUCT_GROUPS = "GET_PRODUCT_GROUPS";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const ADD_COMPANY = "ADD_COMPANY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const DELETE_COMPANY = "DELETE_COMPANY";

export const GET_EMPLOYEES = "GET_EMPLOYEES";
export const ADD_EMPLOYEE = "ADD_EMPLOYEE";
export const UPDATE_EMPLOYEE = "UPDATE_EMPLOYEE";
export const UPDATE_EMPLOYEE_EXP_SALARY = "UPDATE_EMPLOYEE_EXP_SALARY";

export const GET_VENDORS = "GET_VENDORS";
export const ADD_VENDOR = "ADD_VENDOR";
export const UPDATE_VENDOR = "UPDATE_VENDOR";
export const UPDATE_VENDOR_EXP_EXPENSE = "UPDATE_VENDOR_EXP_EXPENSE";

export const GET_SALES_ORDERS = "GET_SALES_ORDERS";
export const ADD_SALES_ORDER = "ADD_SALES_ORDER";
export const UPDATE_SALES_ORDER = "UPDATE_SALES_ORDER";
export const UPDATE_SALES_ORDER_STATUS = "UPDATE_SALES_ORDER_STATUS";
export const UPDATE_SALES_ORDER_PRODUCT_STATUS = "UPDATE_SALES_ORDER_PRODUCT_STATUS";
export const UPDATE_SALES_ORDER_PAYMENT = "UPDATE_SALES_ORDER_PAYMENT";
export const UPDATE_SALES_ORDER_PAY_DATE = "UPDATE_SALES_ORDER_PAY_DATE";
export const SHALLOW_DELETE_SALES_ORDER = "SHALLOW_DELETE_SALES_ORDER";

export const GET_PROCESSES = "GET_PROCESSES";
export const ADD_PROCESSES = "ADD_PROCESSES";
export const UPDATE_PROCESS_STEPS = "UPDATE_PROCESS_STEPS";
export const UPDATE_PROCESS_STEP_COMPLETED = "UPDATE_PROCESS_STEP_COMPLETED";
export const DELETE_PROCESSES = "DELETE_PROCESSES";

export const GET_EXPENSES = "GET_EXPENSES";
export const ADD_EXPENSE = "ADD_EXPENSE";
//export const DELETE_EXPENSE = "DELETE_EXPENSE";

/*
export const GET_EXPENSE_TYPES = "GET_EXPENSE_TYPES";
export const ADD_EXPENSE_TYPE = "ADD_EXPENSE_TYPE";
export const DELETE_EXPENSE_TYPE = "DELETE_EXPENSE_TYPE";

export const GET_FUND_TRANSFERS = "GET_FUND_TRANSFERS";
export const ADD_FUND_TRANSFER = "ADD_FUND_TRANSFER";
*/

export const SET_SO_DISPLAY_ID = "SET_SO_DISPLAY_ID";
export const SET_SO_CUSTOMER_ID = "SET_SO_CUSTOMER_ID";
export const SET_SO_PRODUCTS = "SET_SO_PRODUCTS";
export const SET_SO_DATE = "SET_SO_DATE";
export const SET_SO_STATUS = "SET_SO_STATUS";
export const SET_SO_TOTAL = "SET_SO_TOTAL";
export const SET_SO_PAYMENTS = "SET_SO_PAYMENTS";
export const SET_SO_ACTIVE_STEP = "SET_SO_ACTIVE_STEP";
export const SET_NEW_SO_INFO = "SET_NEW_SO_INFO";
export const CLEAR_NEW_SO = "CLEAR_NEW_SO";

export const GET_ID_GEN = "GET_ID_GEN";
export const INCREMENT_ID_GEN = "INCREMENT_ID_GEN";

export const INCREMENT_FAILED_LOGIN = "INCREMENT_FAILED_LOGIN";
export const RESET_FAILED_LOGIN = "RESET_FAILED_LOGIN";